import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ConfirmModal from '../ConfirmModal/ConfirmModal';
import "./Logout.css";

const Logout = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false); 

  
  const handleShow = () => setShowModal(true);
  
  
  const handleClose = () => setShowModal(false);

  const handleLogout = () => {
    
    localStorage.removeItem("teacher_authToken");
    localStorage.removeItem("userData1");
    localStorage.removeItem("userData");
    localStorage.removeItem("showSyllabus");

    
    navigate("/", { replace: true });
    handleClose(); 
  };

  return (
    <div id="log-out-div">
    
      <button
        className="btn btn-danger"
        id="log-out-btn"
        onClick={handleShow} 
      >
        Çıxış et
      </button>


      <ConfirmModal
        show={showModal}
        onHide={handleClose}
        onConfirm={handleLogout}
        title="Çıxış təsdiqi"
        message="Hesabınızdan çıxış etmək istədiyinizə əminsiniz?"
        confirmText="Bəli, çıxış et"
        cancelText="Xeyr"
        variant="warning"
      />
    </div>
  );
};

export default Logout;